import React from 'react';
import { Col, Row, TextField } from '@folio/stripes-components';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';
import { Field } from 'react-final-form';
import styles from '../styles.css';
import LocalizedTextField from '../../../../../shared/LocalizedTextField';
import {
  composeValidators,
  required,
  validateEnglishOnly,
} from '../../../../../utils/utils';

function CategoryFormFields() {
  return (
    <div className={styles.form_container}>
      <Row className={styles.row_container}>
        <Col xs={6}>
          <FieldArray
            name="name"
            component={LocalizedTextField}
            fieldComponent={TextField}
            subscription={{ value: true }}
            fieldLabel={
              <FormattedMessage
                id="ui-plugin-inventory-templates.customFields.category.editForm.formFields.name"
                defaultMessage="Name"
              />
            }
          />
        </Col>
        <Col xs={6}>
          <FieldArray
            name="description"
            component={LocalizedTextField}
            fieldComponent={TextField}
            subscription={{ value: true }}
            fieldLabel={
              <FormattedMessage
                id="ui-plugin-inventory-templates.customFields.category.editForm.formFields.description"
                defaultMessage="Description"
              />
            }
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Field
            component={TextField}
            fullWidth
            name="code"
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.category.editForm.formFields.code"
                defaultMessage="Code"
              />
            }
            required
            validate={composeValidators(required, validateEnglishOnly)}
            type="text"
          />
        </Col>
      </Row>
    </div>
  );
}

export default CategoryFormFields;
